import React from 'react';

import { Button } from '@vimeo/bokeh';
import { useViewer } from '@vimeo/viewer';

import { useTrackHelpPanelEvent } from '../utils/bigPicture';
import { widgetOpen } from '../utils/widget_actions';

export const ContactUsMenu = () => {
  const viewer = useViewer();
  const trackHelpPanelEvent = useTrackHelpPanelEvent();
  const handleClick = () => {
    widgetOpen(viewer);
    trackHelpPanelEvent({
      eventName: 'vimeo.in_app_support_panel_button_click',
      element: 'button',
      copy: 'contact us',
    });
  };

  return (
    <Button variant="primary" size="sm" onClick={handleClick} mr="2">
      Contact us
    </Button>
  );
};
